//#region src/pd-socialmedia/pd-socialmedia-model.ts
var trim = (s) => s.trim();
var stripAt = (s) => s.replace(/^@/, "");
var ensureHttps = (url) => /^https?:\/\//i.test(url) ? url : `https://${url}`;
var SOCIAL_PROVIDERS = [
	{
		id: "instagram",
		label: "Instagram",
		aliases: ["insta", "ig"],
		category: "Social",
		icon: "📸",
		brandColor: "#E4405F",
		inputKind: "username",
		placeholder: "@deinname",
		pattern: /^[A-Za-z0-9._]{1,30}$/,
		normalize: (raw) => stripAt(trim(raw)),
		toUrl: (input) => `https://instagram.com/${stripAt(trim(input))}`
	},
	{
		id: "tiktok",
		label: "TikTok",
		aliases: ["tiktok"],
		category: "Social",
		icon: "🎵",
		brandColor: "#000000",
		inputKind: "username",
		placeholder: "@deinname",
		pattern: /^[A-Za-z0-9._]{2,24}$/,
		normalize: (raw) => stripAt(trim(raw)),
		toUrl: (input) => `https://www.tiktok.com/@${stripAt(trim(input))}`
	},
	{
		id: "facebook",
		label: "Facebook",
		aliases: ["fb", "facebook page"],
		category: "Social",
		icon: "📘",
		brandColor: "#1877F2",
		inputKind: "url",
		placeholder: "facebook.com/deinprofil",
		pattern: /^https?:\/\/(www\.)?facebook\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "x",
		label: "X (Twitter)",
		aliases: ["twitter"],
		category: "Social",
		icon: "X",
		brandColor: "#000000",
		inputKind: "username",
		placeholder: "@deinname",
		pattern: /^[A-Za-z0-9_]{1,15}$/,
		normalize: (raw) => stripAt(trim(raw)),
		toUrl: (input) => `https://x.com/${stripAt(trim(input))}`
	},
	{
		id: "youtube",
		label: "YouTube",
		aliases: ["yt", "youtube channel"],
		category: "Streaming",
		icon: "▶️",
		brandColor: "#FF0000",
		inputKind: "url",
		placeholder: "youtube.com/@deinname oder Kanal-URL",
		pattern: /^https?:\/\/(www\.)?youtube\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "twitch",
		label: "Twitch",
		aliases: ["twitch tv"],
		category: "Streaming",
		icon: "🎮",
		brandColor: "#9146FF",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9_]{4,25}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://twitch.tv/${trim(input)}`
	},
	{
		id: "soundcloud",
		label: "SoundCloud",
		aliases: ["sc"],
		category: "Music",
		icon: "☁️",
		brandColor: "#FF5500",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9-_.]{3,40}$/,
		normalize: (raw) => trim(raw).replace(/^https?:\/\/(www\.)?soundcloud\.com\//i, ""),
		toUrl: (input) => `https://soundcloud.com/${trim(input)}`
	},
	{
		id: "mixcloud",
		label: "Mixcloud",
		aliases: ["mix cloud"],
		category: "Music",
		icon: "📻",
		brandColor: "#5000FF",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9-_.]{3,40}$/,
		normalize: (raw) => trim(raw).replace(/^https?:\/\/(www\.)?mixcloud\.com\//i, ""),
		toUrl: (input) => `https://www.mixcloud.com/${trim(input)}/`
	},
	{
		id: "hearthis",
		label: "HearThis.at",
		aliases: ["hearthis"],
		category: "Music",
		icon: "🔊",
		brandColor: "#D61C1C",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9-_.]{3,40}$/,
		normalize: (raw) => trim(raw).replace(/^https?:\/\/(www\.)?hearthis\.at\//i, ""),
		toUrl: (input) => `https://hearthis.at/${trim(input)}/`
	},
	{
		id: "beatport",
		label: "Beatport (Artist)",
		aliases: ["beat port"],
		category: "DJ/Booking",
		icon: "🎧",
		brandColor: "#A8E00F",
		inputKind: "url",
		placeholder: "beatport.com/artist/... oder /profile/...",
		pattern: /^https?:\/\/(www\.)?beatport\.com\/(artist|profile)\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "residentadvisor",
		label: "Resident Advisor",
		aliases: ["ra", "ra.co"],
		category: "DJ/Booking",
		icon: "🟢",
		brandColor: "#BADA55",
		inputKind: "url",
		placeholder: "ra.co/dj/deinname",
		pattern: /^https?:\/\/(www\.)?ra\.co\/dj\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "spotify",
		label: "Spotify (Artist)",
		aliases: ["spotify artist"],
		category: "Music",
		icon: "🟢",
		brandColor: "#1DB954",
		inputKind: "id",
		placeholder: "Artist-ID oder vollständige URL",
		pattern: /^[0-9A-Za-z]{22}$|^https?:\/\/open\.spotify\.com\/artist\/[0-9A-Za-z]{22}/i,
		normalize: (raw) => {
			const s = trim(raw);
			const m = s.match(/artist\/([0-9A-Za-z]{22})/);
			return m ? m[1] : s;
		},
		toUrl: (input) => {
			return `https://open.spotify.com/artist/${trim(input).match(/^[0-9A-Za-z]{22}$/) ? input : input.match(/artist\/([0-9A-Za-z]{22})/)?.[1] ?? input}`;
		}
	},
	{
		id: "applemusic",
		label: "Apple Music",
		aliases: ["itunes", "apple music artist"],
		category: "Music",
		icon: "🎵",
		brandColor: "#FA2D48",
		inputKind: "url",
		placeholder: "music.apple.com/... (Artist-Link)",
		pattern: /^https?:\/\/music\.apple\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "deezer",
		label: "Deezer (Artist)",
		aliases: ["deezer"],
		category: "Music",
		icon: "🎶",
		brandColor: "#00C7F2",
		inputKind: "url",
		placeholder: "deezer.com/artist/...",
		pattern: /^https?:\/\/(www\.)?deezer\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "bandcamp",
		label: "Bandcamp",
		aliases: ["band camp"],
		category: "Music",
		icon: "💿",
		brandColor: "#629AA9",
		inputKind: "url",
		placeholder: "deinname.bandcamp.com",
		pattern: /^https?:\/\/[A-Za-z0-9-]+\.bandcamp\.com(\/.*)?$/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "discogs",
		label: "Discogs",
		aliases: ["disc ogs"],
		category: "Catalog",
		icon: "📀",
		brandColor: "#333333",
		inputKind: "url",
		placeholder: "discogs.com/artist/... oder /user/...",
		pattern: /^https?:\/\/(www\.)?discogs\.com\/(artist|user)\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "mixesdb",
		label: "MixesDB",
		aliases: ["mixes db"],
		category: "Catalog",
		icon: "📂",
		brandColor: "#FFB000",
		inputKind: "url",
		placeholder: "mixesdb.com/... (Profil-URL)",
		pattern: /^https?:\/\/(www\.)?mixesdb\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "linkedin",
		label: "LinkedIn",
		aliases: ["li"],
		category: "Social",
		icon: "🔗",
		brandColor: "#0A66C2",
		inputKind: "url",
		placeholder: "linkedin.com/in/deinname",
		pattern: /^https?:\/\/(www\.)?linkedin\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "xing",
		label: "Xing",
		aliases: ["xing profil"],
		category: "Social",
		icon: "🔗",
		brandColor: "#006567",
		inputKind: "url",
		placeholder: "xing.com/profile/deinname",
		pattern: /^https?:\/\/(www\.)?xing\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "github",
		label: "GitHub",
		aliases: ["gh", "git"],
		category: "Developer",
		icon: "🐙",
		brandColor: "#181717",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9-]{1,39}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://github.com/${trim(input)}`
	},
	{
		id: "whatsapp",
		label: "WhatsApp",
		aliases: ["wa"],
		category: "Messaging",
		icon: "💬",
		brandColor: "#25D366",
		inputKind: "url",
		placeholder: "wa.me/491234567890 oder Telefonnummer",
		pattern: /^(\+?[0-9]{7,15}|https?:\/\/(wa\.me|api\.whatsapp\.com)\/.+)$/i,
		normalize: (raw) => {
			const s = trim(raw);
			const m = s.match(/wa\.me\/(\+?[0-9]+)/);
			return m ? m[1] : s.replace(/[^0-9+]/g, "");
		},
		toUrl: (input) => {
			const s = trim(input);
			if (/^https?:\/\//i.test(s)) return s;
			return `https://wa.me/${s.replace(/[^0-9]/g, "")}`;
		}
	},
	{
		id: "telegram",
		label: "Telegram",
		aliases: ["tg"],
		category: "Messaging",
		icon: "💬",
		brandColor: "#26A5E4",
		inputKind: "username",
		placeholder: "@deinname oder t.me/deinname",
		pattern: /^[A-Za-z0-9_]{5,32}$/,
		normalize: (raw) => stripAt(trim(raw)).replace(/^https?:\/\/t\.me\//i, ""),
		toUrl: (input) => `https://t.me/${stripAt(trim(input))}`
	},
	{
		id: "stackoverflow",
		label: "Stack Overflow",
		aliases: ["so", "stack overflow"],
		category: "Developer",
		icon: "📋",
		brandColor: "#F58025",
		inputKind: "url",
		placeholder: "stackoverflow.com/users/123456/deinname",
		pattern: /^https?:\/\/(www\.)?stackoverflow\.com\/users\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "dribbble",
		label: "Dribbble",
		aliases: ["dribble"],
		category: "Design",
		icon: "🏀",
		brandColor: "#EA4C89",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9_-]{1,40}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://dribbble.com/${trim(input)}`
	},
	{
		id: "behance",
		label: "Behance",
		aliases: ["be"],
		category: "Design",
		icon: "🎨",
		brandColor: "#1769FF",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9_-]{1,40}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://www.behance.net/${trim(input)}`
	},
	{
		id: "pinterest",
		label: "Pinterest",
		aliases: ["pin"],
		category: "Social",
		icon: "📌",
		brandColor: "#BD081C",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9_-]{3,30}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://pinterest.com/${trim(input)}`
	},
	{
		id: "threads",
		label: "Threads",
		aliases: ["meta threads"],
		category: "Social",
		icon: "🧵",
		brandColor: "#000000",
		inputKind: "username",
		placeholder: "@deinname",
		pattern: /^[A-Za-z0-9._]{1,30}$/,
		normalize: (raw) => stripAt(trim(raw)),
		toUrl: (input) => `https://www.threads.net/@${stripAt(trim(input))}`
	},
	{
		id: "bluesky",
		label: "Bluesky",
		aliases: ["bsky"],
		category: "Social",
		icon: "🦋",
		brandColor: "#0085FF",
		inputKind: "username",
		placeholder: "deinname.bsky.social",
		pattern: /^[A-Za-z0-9._-]+(\.[A-Za-z0-9._-]+)*$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://bsky.app/profile/${trim(input)}`
	},
	{
		id: "snapchat",
		label: "Snapchat",
		aliases: ["snap"],
		category: "Social",
		icon: "👻",
		brandColor: "#FFFC00",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9._-]{3,15}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://www.snapchat.com/add/${trim(input)}`
	},
	{
		id: "discord",
		label: "Discord",
		aliases: ["dc"],
		category: "Community",
		icon: "💬",
		brandColor: "#5865F2",
		inputKind: "url",
		placeholder: "discord.gg/invite-code",
		pattern: /^https?:\/\/(www\.)?(discord\.(gg|com\/invite))\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "reddit",
		label: "Reddit",
		aliases: ["subreddit"],
		category: "Community",
		icon: "🤖",
		brandColor: "#FF4500",
		inputKind: "url",
		placeholder: "reddit.com/r/... oder /user/...",
		pattern: /^https?:\/\/(www\.)?reddit\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "vimeo",
		label: "Vimeo",
		aliases: ["vimeo channel"],
		category: "Streaming",
		icon: "🎬",
		brandColor: "#1AB7EA",
		inputKind: "url",
		placeholder: "vimeo.com/deinname",
		pattern: /^https?:\/\/(www\.)?vimeo\.com\/.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "mastodon",
		label: "Mastodon",
		aliases: ["fediverse", "masto"],
		category: "Social",
		icon: "🐘",
		brandColor: "#6364FF",
		inputKind: "url",
		placeholder: "mastodon.social/@deinname",
		pattern: /^https?:\/\/.+\/@.+/i,
		toUrl: (input) => ensureHttps(trim(input))
	},
	{
		id: "medium",
		label: "Medium",
		aliases: ["blog"],
		category: "Blogging",
		icon: "✍️",
		brandColor: "#000000",
		inputKind: "username",
		placeholder: "@deinname",
		pattern: /^@?[A-Za-z0-9._-]{1,40}$/,
		normalize: (raw) => stripAt(trim(raw)),
		toUrl: (input) => `https://medium.com/@${stripAt(trim(input))}`
	},
	{
		id: "patreon",
		label: "Patreon",
		aliases: ["patron"],
		category: "Support",
		icon: "❤️",
		brandColor: "#FF424D",
		inputKind: "username",
		placeholder: "deinname",
		pattern: /^[A-Za-z0-9_-]{1,40}$/,
		normalize: (raw) => trim(raw),
		toUrl: (input) => `https://www.patreon.com/${trim(input)}`
	}
];
//#endregion
export { SOCIAL_PROVIDERS };
